import { menuKey,dropLists } from '@/request/common.js'

export default {
  data() {
    return {
      pbk: "",
      keyToken: "",
    };
  },
  methods: {
    async getStatus(
    types = "1",
    dict,
    datas,
    defaultKey,
    defaultData,
    isMultiple,
    sourceData
  ) {
    // const dropLists = this.$api.dropLists;
    // types  1 、表单提交 2 、表单筛选 3、处理数据
    // dict 字典编码
    // datas 需要赋值集合的变量名称-不可以用多级 例如 this.arrays 传 arrays 即可
    // defaultKey 需要赋值默认值的变量名称-可以使用多级 例如 this.form.status 传 form.status 即可
    // isMultiple 是否为多选
    var res = {};
    if (types == "3") {
      res = sourceData;
    } else {
      res = await dropLists({
        dictTypes: [dict],
      });
    }
    function dealArray(arrays) {
      arrays = arrays || [];
      return arrays.map((si) => {
        let obj = {
          name: si.dictValue,
          title: si.dictValue,
          text: si.dictValue,
          label: si.dictValue,
          value: si.dictCode,
          id: si.dictCode,
          allName: si["dictAllName"],
          allValue: si["dictAllCode"],
          parentId: si["dictParentCode"],
          remark:si.dictRemark || '',
        };
        if (si["children"] && si["children"].length > 0) {
          obj["children"] = dealArray(si.children);
        }
        return obj;
      });
    }
    let arrays = dealArray(res.data[dict]);
    if (res.code == 200) {
      if (types == "2") {
        arrays.unshift({ title: "全部",text: "全部",label: "全部", value: "" });
      }
      this[datas] = arrays;
    } else {
      this[datas] = [];
    }
    // 如果传了默认值
    if (defaultKey) {
      const _this = this;
      let defaultValue;
      if (defaultData) {
        let isDefaultData = res.data[dict].filter((si) => {
          return si.dictValue === defaultData;
        });
        if (isDefaultData.length > 0) {
          defaultValue = isDefaultData[0]["dictCode"];
        }
      }
      let lengths = res.data[dict].filter((si) => {
        return si.dictHasDefault === "0";
      });
      if (lengths.length > 0) {
        if (isMultiple) {
          defaultValue = lengths.map((si) => {
            return si["dictCode"];
          });
        } else {
          defaultValue = lengths[lengths.length - 1]["dictCode"];
        }
      }
      let defaultArray = defaultKey.split(".").filter((si) => si != "");
      if (defaultArray.length == 1) {
        _this[defaultArray[0]] = defaultValue;
      } else {
        defaultArray.reduce((a, b, index) => {
          if (index == defaultArray.length - 1) {
            if (toString.call(a) == "[object Object]") {
              return a[b];
            } else {
              _this[a][b] = defaultValue;
            }
          } else {
            if (toString.call(a) == "[object Object]") {
              return a[b];
            } else {
              return _this[a][b];
            }
          }
        });
      }
    }
  },
    async menuKeySvc() {
      const res = await menuKey();
      this.pbk = res.data.publicKey;
      this.keyToken = res.data.keyToken;
    },
  },
};
